<template lang="html">
  <div class="vs-list--item flex justify-between ">
      <div>
          <div style="padding: 10px 0px;font-weight: 400;"
               v-if="title"
               class="vs-list--title">
              <label style="color: #d92121">{{ $t('teacher') }}:</label> <span> {{ item.teacher.name_initial }} </span><br>
              <label style="color: #d92121">{{ $t('load_type') }}:</label> <span> {{ item.load_type.name }} </span><br>
              <label style="color: #d92121"> CR: </label> <span> {{ item.number_of_students_registered }}/{{ item.number_of_students }} </span><br>
              <label style="color: #d92121"> AU: </label> <span> {{ item.number_of_students_audit_registered}}/{{ item.number_of_students_audit }} </span><br>
              <label style="color: #d92121">{{ $t('day_week') }}:</label> <span> {{ $t(item.day_week.name.toLowerCase() ) }} </span><br>
              <label style="color: #d92121">{{ $t('schedule') }}:</label> <span> {{ item.from_time.from_time}} - {{ item.from_time.to_time}} </span><br>
          </div>

          <slot v-else name="title" />
      </div>
        <div>
            <multiselect
                :disabled="user.role.is_supervisor"
                @select="change_status_lesson"
                :options="GET_STATUS_COURSE"
                selectedLabel=""
                open-direction="bottom"
                v-model="item.status"
                label="name"
                deselectLabel=""
                :allow-empty="false"
                selectLabel=""
                track-by="uid">
                <div slot="noOptions">
                    {{$t('no_data_text')}}
                </div>
            </multiselect>
        </div>


  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name:'VsListItem',
    props: {
        vsAvatar:{
            type:[Boolean,String],
            default:false,
        },
        title:{
            type:String,
            default:null,
        },
        subtitle:{
            type:String,
            default:null,
        },
        icon:{
            type:String,
            default:null,
        },
        iconPack:{
            type:String,
            default:'material-icons',
        },
        item:Object,
        course_index: {
            type: Number,
            default: null,
        },
        flux_index: {
            type: Number,
            default: null,
        },
        lesson_index: {
            type: Number,
            default: null,
        },
        course_uid: {
            type:String,
        }
    },
    computed:{
        ...mapGetters({
            GET_STATUS_COURSE:'discipline_registration_access/GET_STATUS_COURSE'
        }),
        user() {
            return this.$store.state.user.user
        },
    },
    methods:{
        ...mapActions({
            CHANGE_LESSONS:'online_registration/CHANGE_LESSONS'
        }),
        ...mapMutations({
            CHANGE_STATUS_LESSON: 'discipline_registration_access/CHANGE_STATUS_LESSON',
        }),
        async change_status_lesson(val){
            this.CHANGE_STATUS_LESSON({
                course_index: this.course_index,
                flux_index: this.flux_index,
                lesson_index: this.lesson_index,
                lesson_uid: this.item.uid,
                status: val,
            })
            await this.CHANGE_LESSONS({
                data:{
                    data: [this.item.uid],
                    status: val ? val.uid : null,
                    course_uid: this.course_uid,
                },
                params: {}
            })
        }
    }
}
</script>
<style lang="scss">
.multiselect__option--selected{
    background-color: rgba(var(--vs-primary), 1);
    color: rgb(255, 255, 255);
}
</style>
